import n from "./td-longtail-vue-components245.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var c = function() {
  var e = this, t = e._self._c, s = e._self._setupProxy;
  return t("div", { staticClass: "single-item-configurator" }, e._l(s.filteredVariants, function(r, i) {
    return t("div", { key: i, staticClass: "single-item-configurator__variant-group" }, [t(s.VariantSelector, { attrs: { "display-name": r.displayName, type: r.type, "is-accessible": e.isAccessible, variants: r.items }, on: { "select-variant": (a) => e.$emit("select-variant", a) } })], 1);
  }), 0);
}, l = [], _ = /* @__PURE__ */ o(
  n,
  c,
  l,
  !1,
  null,
  "eefb2e43"
);
const d = _.exports;
export {
  d as default
};
